<template>
	<v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12">
			<crud
				title='Job Sincronizzazione'
				action-icon='sync_alt'
				model-def='jobs'
				action-position='absolute'
				:crud-dialog="true"
			    class="mt-4 round-card background-2 elevation-1"
			></crud>
		</v-col>
        <v-col class="pa-0" cols="12">
			<crud
				title='Log'
				action-icon='bug_report'
				model-def='yellologs'
				action-position='absolute'
				:crud-dialog="true"
			    class="mt-4 round-card background-2 elevation-1"
			></crud>
		</v-col>
		<v-col class="pa-0" cols="12" v-if="$store.getters.checkModelPermissions('setting')">
			<crud
				title='Log Automazioni'
				action-icon='mdi-sitemap-outline'
				model-def='automationlogs'
				action-position='absolute'
				:crud-dialog="true"
			    class="mt-4 round-card background-2 elevation-1"
			></crud>
		</v-col>
	</v-row>
</template>
<script>

	export default {
		name:'logs',
		
		data() {
			return {
				
			}
		},
	}
  </script>
